import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import config from '../../config/config';
import { toastError } from '../../utils/toasts';
import describeRequestError from '../../utils/describeRequestError';
import { logout } from '../slices/auth';
// import { logout } from '../slices/auth';

interface State {
  auth: { token: string; userData: unknown }
}

const baseQuery = fetchBaseQuery({
  baseUrl: `${config.baseURL}/v1/`,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as State).auth;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

// `extraOptions: { silent: true }` on an endpoint skips the error toast: for
// background polls and for batches that show one summary message themselves.
export interface BaseQueryExtraOptions {
  silent?: boolean;
}

const baseQueryWithReauth = async (args: string | FetchArgs, api: BaseQueryApi, extraOptions?: BaseQueryExtraOptions) => {
  const result = await baseQuery(args, api, {});
  if (result.meta?.response?.status === 401) {
    api.dispatch(logout());
  } else if (result.error && !extraOptions?.silent) {
    const errorMessage = describeRequestError(result.error);
    if (errorMessage) {
      toastError(errorMessage);
    }
  }
  return result;
};

export default baseQueryWithReauth;
